<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:16:34
-->
<template>
  <div>
    <div class="top">
      <div v-if="codeData.indexOf('65') != -1"  @click="batchDeletion" class="batch-operation">
        <el-button type="primary"> 批量删除 </el-button>
      </div>
      <div class="search">
        <a-input
          v-model:value="value"
          placeholder="问题关键字搜索"
          style="width: 173px; margin-right: 12px"
        />
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <coententTable
      :isSelectRow="true"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
       @selectedRowKeys="selectedRowKeys"
       :rowKeys="rowKeys"
    >
      <template v-slot:operation="scopeVal">
        <div class="btnThree" v-if="codeData.indexOf('64') != -1" @click="open(scopeVal.scope)">删除</div>
      </template>
    </coententTable>
    <el-dialog
      title="确认删除问题?"
      :visible.sync="deleteShow"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShow = false">取消</el-button>
        <el-button :loading="deleteShowLoadingTwo" type="danger" @click="deleteFn">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认删除问题?"
      :visible.sync="deleteShowTwo"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteShowTwo = false">取消</el-button>
        <el-button :loading="deleteShowLoading" type="danger" @click="deleteFnTwo">确认删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { selectPage, deleteUnknownQuestion,deleteUnknownQuestionIds } from "./index";
import { message } from 'ant-design-vue';
export default {
  data() {
    return {
      height: 0,
      value: "",
      deleteShowLoading:false,
      deleteShowLoadingTwo:false,
      columns: [
        {
          title: "问题",
          dataIndex: "unknownQuestion",
          ellipsis: true,
          customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
        },
        {
          title: "提问时间",
          dataIndex: "quizTime",
          ellipsis: true,
          width: 200,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 100,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      loading: false,
      deleteShow: false,
      item: {},
      deleteShowTwo: false,
      rowKeys:[],
      codeData:[],
    };
  },
  components: {
    coententTable,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    batchDeletion() {
        if(this.rowKeys.length == 0){
            message.error('请选择操作项');
            return;
        }
      this.deleteShowTwo = true;
    },
     selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    deleteFnTwo(){
        this.deleteShowLoading = true;
        deleteUnknownQuestionIds({
            idList:this.rowKeys,
        }).then((res)=>{
            if(res.code == 0){
                this.getList();
                 this.deleteShowTwo = false;
                  this.deleteShowLoading = false;
            }
        })
    },
    open(item) {
      this.deleteShow = true;
      this.item = item;
    },
    deleteFn() {
      this.deleteShowLoadingTwo = true;
      deleteUnknownQuestion({
        id: this.item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.deleteShow = false;
           this.deleteShowLoadingTwo = false;
          this.getList();
        }
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
    search() {
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      selectPage({
        unknownQuestion: this.value,
        current: this.pagination.current,
        size: this.pagination.pageSize,
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = res.data.records;
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          if( this.pagination.total > 0){
            this.height = document.documentElement.clientHeight - 370;
            window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 370;
              })();
            };
          }
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  .batch-operation {
    margin-left: 10px;
    /deep/ .ant-btn,
    .ant-dropdown-trigger {
      height: 35px;
      background: #ecf5ff;
      color: #18abff;
      border-color: #c9e3ff;
      text-align: center;
    }
  }
  .search {
            display: flex;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
}
 .el-button--primary {
  background: #176de6;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>